
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { VPNSection } from './components/VPNSection';
import { FeaturesSection } from './components/FeaturesSection';
import { ContactSection } from './components/ContactSection';
import { AboutSection } from './components/AboutSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <VPNSection />
        <FeaturesSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
